import TabGroupSeguros from '@/components/molecules/TabGroupSeguros';
import { SeguroTabs } from '@/data/misc/seguros-tabs';

export default function CDCProtegidoPage() {
  return <TabGroupSeguros tab={SeguroTabs['cdc-protegido'].id} />;
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
